export default __webpack_public_path__ + "static/media/wojakSquare.5ee0a857.svg";